import script from "./AISideBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AISideBar.vue?vue&type=script&lang=ts&setup=true"

import "./AISideBar.vue?vue&type=style&index=0&id=11890d53&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11890d53"]])

export default __exports__